import * as React from 'react';

// Lock Icon for the dashboard cards 
export const CardLockIcon = (

):JSX.Element => {
    return (
        // creating Lock Icon using antd design for card lock
        <div className={"ant-empty ant-empty-normal"}>
            <div className="ant-empty-image_lock_icon">
                <svg focusable='false' width="4em" height="4em" viewBox="64 64 896 896" fill='currentcolor' aria-hidden='true' data-icon='lock' xmlns="http://www.w3.org/2000/svg">
                    <path d="M 832 464 h -68 V 240 c 0 -70.7 -57.3 -128 -128 -128 H 388 c -70.7 0 -128 57.3 -128 128 v 224 h -68 c -17.7 0 -32 14.3 -32 32 v 384 c 0 17.7 14.3 32 32 32 h 640 c 17.7 0 32 -14.3 32 -32 V 496 c 0 -17.7 -14.3 -32 -32 -32 Z M 332 240 c 0 -30.9 25.1 -56 56 -56 h 248 c 30.9 0 56 25.1 56 56 v 224 H 332 V 240 Z m 460 600 H 232 V 536 h 560 v 304 Z M 484 701 v 53 c 0 4.4 3.6 8 8 8 h 40 c 4.4 0 8 -3.6 8 -8 v -53 a 48.01 48.01 0 1 0 -56 0 Z" className="warning_lock_icon"></path>
                </svg>
            </div>
        </div>
    );
};
